import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";

const PersonDetailDocument = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={12}>
          <NFTextInput title={t("Type")} fieldName={"type"} />
        </Col>
        <Col sm={12}>
          <NFTextInput title={t("Series")} fieldName={"series"} />
        </Col>
        <Col sm={12}>
          <NFTextInput title={t("Number")} fieldName={"Number"} />
        </Col>
        <Col sm={12}>
          <NFTextInput title={t("IssuedBy")} fieldName={"issuedBy"} />
        </Col>
        <Col sm={12}>
          <NFTextInput title={t("IssuedDate")} fieldName={"issuedDate"} />
        </Col>
      </Row>
    </>
  );
};

export default PersonDetailDocument;
